import React, { useState, useEffect } from 'react';

const StatusDropdown = ({ initialStatus, lineIndex, detailIndex, handleChange, disabled }) => {
  const [status, setStatus] = useState(initialStatus);
  const [previousStatus, setPreviousStatus] = useState(initialStatus);
  const [availableOptions, setAvailableOptions] = useState([]);

  const allStatuses = [
    'Received',
    'InProcess',
    'Shipped',
    'Delivered',
    'Exception',
    'Refused',
    'Cancelled'
  ];

  const getNextStatusOptions = (currentStatus, previousStatus) => {
    const currentIndex = allStatuses.indexOf(currentStatus);
    const previousIndex = allStatuses.indexOf(previousStatus);

    if (currentIndex === -1 || previousIndex === -1) return allStatuses;

    if (currentIndex > previousIndex) {
      return [currentStatus, previousStatus, 'Cancelled'];
    } else {
      if (currentStatus === 'Shipped' || currentStatus === 'Delivered' || currentStatus === 'Exception' || currentStatus === 'Refused' || currentStatus === 'Cancelled') {
        return ['Shipped', 'Delivered', 'Exception', 'Refused', 'Cancelled'];
      }
      const nextStatus = allStatuses[currentIndex + 1];
      return nextStatus ? [currentStatus, nextStatus, 'Cancelled'] : [currentStatus, 'Cancelled'];
    }
  };

  useEffect(() => {
    setAvailableOptions(getNextStatusOptions(status, previousStatus));
  }, [status, previousStatus]);

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    setPreviousStatus(status); // Update the previous status
    setStatus(newStatus);
    handleChange(e, lineIndex, detailIndex); // Assuming this function will update the status in the parent component
  };

  return (

      <select
        className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
        name="status"
        value={status}
        onChange={handleStatusChange}
        disabled={disabled}
        title=""
      >
        {availableOptions.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

  );
};

export default StatusDropdown;